import { OnAppInit } from '@frontend/vanilla/core';

import { IUiChangeHandler } from './ui-change-handler';
import { UiManagerService } from './ui-manager.service';
import { IUiState } from './ui-manager.state';
import { UiStates } from './ui-states.enum';

export abstract class BaseUiChangeHandler implements IUiChangeHandler, OnAppInit {
    protected constructor(protected uiManager: UiManagerService) {}

    onAppInit(): void | Promise<any> {
        this.uiManager.registerUiHandler(this);
    }

    abstract updateUi(prev: IUiState, next: IUiState): void | Promise<any>;

    inState(uiState: IUiState, state: UiStates): boolean {
        return !!(uiState && uiState.states.some((s) => s === state));
    }

    isStateAdded(prev: IUiState, next: IUiState, state: UiStates): boolean {
        return !!((!prev || prev.states.every((s) => s !== state)) && next && next.states.some((s) => s === state));
    }

    isStateRemoved(prev: IUiState, next: IUiState, state: UiStates): boolean {
        return !!(prev && prev.states.some((s) => s === state) && (!next || next.states.every((s) => s !== state)));
    }
}
